/* unplugin-vue-components disabled */import { render } from "./ShareUserRule.vue?vue&type=template&id=bd91fa76&scoped=true"
import script from "./ShareUserRule.vue?vue&type=script&lang=js"
export * from "./ShareUserRule.vue?vue&type=script&lang=js"

import "./ShareUserRule.vue?vue&type=style&index=0&id=bd91fa76&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd91fa76"]])

export default __exports__